<script lang="ts" setup>
import SidebarMenu from "../../SidebarMenu";
import { useApp } from "../../../../store";

const title = "Modules";
const app = useApp();

app.fetchModulesMenuItems();
</script>

<template>
  <SidebarMenu
    :title="title"
    :items="app.modulesMenuItems || []"
    role="navigation"
    aria-label="Main menu"
  />
</template>
